import { Component, OnChanges, Input, SimpleChanges } from "@angular/core";
import { ControlContainer, NgForm } from "@angular/forms";

@Component({
  selector: "suppliers-component",
  template: require('./suppliers.component.html'),
  styles: [require('./suppliers.component.scss')],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SuppliersComponent implements OnChanges {
  @Input("item") item: any;
  @Input("companyList") companyList: any;
  companies: any[] = this.companyList;
  companyNames: { [name: string]: string } = {};
  companyId: string;
  activePanels: string[] = ["supplier"];

  ngOnChanges(changes: SimpleChanges) {
    if (this.companyList) {
      this.companies = this.companyList;
      this.companyNames = this.companyList.reduce(
        (p, c) => ({ ...p, [c.id]: c.name }),
        {}
      );
    }
  }

  addCompany() {
    this.item.suppliers = [
      ...(this.item.suppliers || []),
      { suppliers: [], active: false, company_id: "" }
    ];
  }

  removeListItem(supplier) {
    this.item.suppliers = (this.item.suppliers || []).filter(
      it => it != supplier
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/suppliers/suppliers.component.ts